import React from 'react';

export const roboto = {
  fontFamily: 'Roboto',
  fontWeight: '100 1000',
  url: require('./Assets/RobotoFlex.woff2'),
  format: 'woff2',
};

export function RobotoFontFace() {
  return (
    <style>
      {`
      @font-face {
        font-family: Roboto;
        font-weight: 100 1000;
        src: url('${require('./Assets/RobotoFlex.woff2')}') format('woff2');
      }
    `}
    </style>
  );
}
